import { Component, Input, OnInit, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { ProfileService } from '../../shared/profile.service';
import { ProfileRead } from '../../shared/profile-read.model';
import { ObservationService } from '../../../shared/observation/observation.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'wl-profile-history',
  templateUrl: 'profile-history.component.html',
  styleUrls: ['profile-history.component.less'],
    standalone: false
})
export class ProfileHistoryComponent implements OnInit, OnChanges, OnDestroy {
  private _profileService: ProfileService;

  public profile: ProfileRead;
  private _observationService: ObservationService;
  private _profileSubscription: Subscription;
  public dateCreated: Date;
  public dateChanged: Date;

  @Input() public profileId: number;

  public constructor(profileService: ProfileService, observationService: ObservationService) {
    this._profileService = profileService;
    this._observationService = observationService;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadProfile();
  }

  ngOnDestroy(): void {
    if (this._profileSubscription) {
      this._profileSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    this._profileSubscription = this._observationService.observeProfiles().subscribe((id) => {
      this.profileUpdated(id);
    });

    this.loadProfile(true);
  }

  private profileUpdated(id: number) {
    if (id === this.profileId) {
      this.loadProfile(true);
    }
  }

  public loadProfile(forceRefresh?: boolean) {
    this._profileService.getProfile(this.profileId, forceRefresh).then((data: ProfileRead) => {
      this.dateCreated = data.DateCreated;
      this.dateChanged = data.DateChanged;
    });
  }
}
